export const MAX_HEIGHT_ORIGINALS = 0.6;
export const HALF_HEIGHT = 0.5;
export const IMAGE_INSET_MULTIPLIER = 13;
export const IMAGE_BORDER_RADIUS = 24;
export const BASE_REFERENCE_HEIGHT = 820;
export const BASE_REFERENCE_WIDTH = 375;

export const MIN_SWIPE_DISTANCE = 50;
